export const ESCAPE = "Escape";
export const ENTER = "Enter";
export const SPACE = "Space";
export const LEFT = "ArrowLeft";
export const RIGHT = "ArrowRight";
export const UP = "ArrowUp";